import styled from 'styled-components';

export const Container = styled.div`
  width: 50%;
  height: 26rem;
  padding: 1rem 2rem 0 2rem;
  border: 2px solid #6b6b6b6b;
  border-radius: 1rem;
  text-align: center;
  background-color: #fff;
  h1 {
    font-size: 11px;
    font-weight: 600;
    color: #000000;
    margin-bottom: 1.5rem;
  }
  @media (min-width: 2000px) {
    height: 100%;
  }
  @media (max-width: 1366px) {
    padding: 0.5rem 1rem 0 1rem;
  }
  @media (max-width: 769px) {
    width: 100%;
    margin: 1rem 0;
  }
`;
export const ContainerOverview = styled.div`
  width: 50%;
  height: 26rem;

  padding: 1rem 2rem 0 2rem;
  border: 2px solid #6b6b6b6b;
  border-radius: 1rem;
  text-align: center;
  background-color: #fff;
  margin: 0 1rem 0 1rem;
  div {
    display: flex;
    margin-bottom: 0.5rem;
    h1 {
      font-size: 11px;
      font-weight: 600;
      color: #000000;
      margin-right: 1rem;
    }
    div {
      label {
        font-size: 11px;
        font-weight: 600;
        color: #000000;
        margin-right: 1rem;
      }
      select {
        border: none;
        font-size: 11px;
        font-weight: 800;
        color: #000000;
      }
    }
  }
  @media (min-width: 2000px) {
    height: 100%;
  }
  @media (max-width: 1366px) {
    padding: 0.5rem 1rem 0 1rem;
  }
  @media (max-width: 769px) {
    width: 100%;
    margin: 0;
  }
`;
export const ReviewChartContainer = styled.div`
  width: 100%;
  height: 48%;
  overflow: hidden;
  padding: 0.5rem 1rem 1rem 0;
  border: 2px solid #6b6b6b6b;
  border-radius: 1rem;
  text-align: center;
  background-color: #fff;
  h1 {
    font-size: 10px;
    font-weight: 600;
    color: #000000;
    margin-bottom: -1rem;
  }
  @media (max-width: 1366px) {
    padding: 0.5rem 0.5rem 0.5rem 0;
  }
`;
